/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class BillingAddress extends RiskFactor {
    static getCondition({billingAddress, riskMetadata}) {
        return !!billingAddress && !!riskMetadata;
    }

    parse({billingAddress, riskMetadata}) {
        this.billingAddress = billingAddress;
        this.riskMetadata = riskMetadata;

        if (this.billingAddress.country === null
            || this.riskMetadata.country === null) {
            this.icon = 'dash-l';
            this.className = 'icon-yellow';
            this.result = 'Billing country and/or country from which the order was placed is not available';
        } else if (this.billingAddress.country === this.riskMetadata.country) {
            this.icon = 'check-s';
            this.className = 'icon-green';
            this.result = 'Billing country matches the country from which the order was placed';
        } else {
            this.icon = 'close-s';
            this.className = 'icon-red';
            this.result = 'Billing country does not match the country from which the order was placed';
        }
    }

    getResult() {
        return this.result;
    }
}
